import { MarketAdjustmentWritable } from 'api';
import { MarketAdjustment } from 'pages/FundInvestments/pages/FundInvestmentMarketAdjustment';
import { getObjectValue } from 'utilities';

const parseValuationMarketAdjustment = (
  valuationMarketAdjustment: MarketAdjustmentWritable
): MarketAdjustment => {
  const {
    adjustment_selection: adjustmentSelection,
    as_of_date: asOfDate,
    id,
    market_adjustment: marketAdjustment,
    metric_selection: metricSelection,
    name,
    percentile_selection_a: percentileSelectionA,
    percentile_selection_b: percentileSelectionB,
    specified_adjustment: specifiedAdjustment,
    valuation,
  } = getObjectValue(valuationMarketAdjustment);

  return {
    adjustment_selection: adjustmentSelection,
    as_of_date: asOfDate,
    id,
    market_adjustment: marketAdjustment,
    metric_selection: metricSelection,
    name,
    percentile_selection_a: percentileSelectionA,
    percentile_selection_b: percentileSelectionB,
    specified_adjustment: specifiedAdjustment,
    valuation,
  } as MarketAdjustment;
};

export default parseValuationMarketAdjustment;
